
/*
 * Montclair & Vale
 * Welcome announcement popup — TEST VERSION
 */

(function () {
  if (window.mvWelcomePopupInitialized) return;
  window.mvWelcomePopupInitialized = true;

  document.addEventListener('click', function (event) {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const slide = target.closest('.announcement-bar__slide');
    if (!slide) return;

    const welcomeLink =
      slide.querySelector('[data-mv-open-welcome-popup]');

    if (!welcomeLink) return;

    if (
      !target.closest('.announcement-bar__text') &&
      !target.closest('[data-mv-open-welcome-popup]')
    ) return;

    // Never redirect the welcome announcement to the footer.
    event.preventDefault();

    const forms = document.querySelectorAll('shopify-forms-embed');

    for (const form of forms) {
      const teaser = form.shadowRoot?.querySelector(
        'button[data-testid="form-teaser"][aria-label="GET 10% OFF"]'
      );

      if (teaser) {
        teaser.click();
        return;
      }
    }

    // No teaser available: remain on the current page.
  });
})();
